import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { appRoutes } from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { ExchangeRateProvider } from './contexts/ExchangeRateContext';
import { ToastProvider } from './contexts/ToastContext';

const router = createBrowserRouter(appRoutes);

export const App = () => (
  <FluentProvider theme={webLightTheme}>
    {/* ToastProvider embeds the single <Toaster /> instance — do NOT add another <Toaster /> here */}
    <ToastProvider>
      <AuthProvider>
        <ExchangeRateProvider>
          <RouterProvider router={router} />
        </ExchangeRateProvider>
      </AuthProvider>
    </ToastProvider>
  </FluentProvider>
);
